import { useTheme } from '@emotion/react';
import { complement, shade, tint } from 'polished';

const useAffiliateColors = (color: string | undefined) => {
  const theme = useTheme();

  // If no color is provided or if it matches the default FLOYT green, return no colors.
  if (!color || color === theme.colors.brand.green100) {
    return {};
  }

  // Otherwise, return a custom brand color palette for the affiliate.
  return {
    green160: shade(0.6, color),
    green140: shade(0.4, color),
    green120: shade(0.2, color),
    green100: shade(0, color),
    green80: tint(0.2, color),
    green60: tint(0.4, color),
    green40: tint(0.6, color),
    green20: tint(0.8, color),
    orange160: complement(shade(0.6, color)),
    orange140: complement(shade(0.4, color)),
    orange120: complement(shade(0.2, color)),
    orange100: complement(shade(0, color)),
    orange80: complement(tint(0.2, color)),
    orange60: complement(tint(0.4, color)),
    orange40: complement(tint(0.6, color)),
    orange20: complement(tint(0.8, color)),
  };
};

export { useAffiliateColors };
